import { HomePage, CustomersPage, OrdersPage, ArticlesPage, TestPage } from './pages';
import { withNavigationWatcher } from './contexts/navigation';

const routes = [
    // {
    //     path: '/tasks',
    //     element: TasksPage
    // },
    // {
    //     path: '/profile',
    //     element: ProfilePage
    // },
    {
        path: '/home',
        element: HomePage
    },
    {
        path: '/customers',
        element: CustomersPage
    },
    {
        path: '/orders/:tipo',
        element: OrdersPage
    },
    // {
    //     path: '/test',
    //     element: TestPage
    // }

];

export default routes.map(route => {
    return {
        ...route,
        element: withNavigationWatcher(route.element, route.path)
    };
});
